import { Account } from 'entities/user/module'

import { preparePhoneNumber } from 'shared/lib/prepare-phone-number'

import {
  InsuranceCitizenship,
  InsuranceParticipantData,
  InsurancePolicyholderData,
} from './types'

export const createEmptyInsuranceParticipant =
  (): InsuranceParticipantData => ({
    lastName: '',
    firstName: '',
    inn: '',
    birthDate: '',
    passportNumber: '',
    citizenship: null,
  })

export const resizeInsuranceParticipants = (
  participants: InsuranceParticipantData[],
  count: number,
): InsuranceParticipantData[] =>
  Array.from(
    { length: count },
    (_, index) => participants[index] ?? createEmptyInsuranceParticipant(),
  )

export const createEmptyInsurancePolicyholder =
  (): InsurancePolicyholderData => ({
    ...createEmptyInsuranceParticipant(),
    citizenship: null,
    phone: preparePhoneNumber(),
  })

export const prepareSelfInsurancePolicyholder = (
  account: Account | null,
  citizenships: InsuranceCitizenship[],
): InsurancePolicyholderData => {
  const passport = account?.international_passport
  const citizenshipNames = [
    passport?.citizenship_obj?.country,
    account?.citizenship_obj?.country,
    passport?.citizenship,
    account?.citizenship,
  ]
    .filter((name): name is string => Boolean(name))
    .map((name) => name.trim().toLocaleLowerCase())
  const citizenship = citizenships.find(({ name }) =>
    citizenshipNames.includes(name.trim().toLocaleLowerCase()),
  )

  return {
    lastName: passport?.last_name || account?.last_name || '',
    firstName: passport?.first_name || account?.first_name || '',
    inn: account?.document_inn || '',
    birthDate: passport?.date_of_birth || account?.date_of_birth || '',
    passportNumber: passport?.document_number || '',
    citizenship: citizenship || null,
    phone: preparePhoneNumber(account?.phone_number),
  }
}
